
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";
import CSVImportDialog from "./CSVImportDialog";

interface CSVImportButtonProps {
  onImportComplete?: (results: { success: number; failed: number }) => void;
  variant?: "default" | "outline" | "secondary" | "ghost" | "link";
  size?: "default" | "sm" | "lg" | "icon";
  className?: string;
}

const CSVImportButton: React.FC<CSVImportButtonProps> = ({
  onImportComplete,
  variant = "outline",
  size = "sm",
  className
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={className}
        onClick={() => setIsDialogOpen(true)}
      >
        <Upload className="h-4 w-4 mr-2" />
        Import CSV
      </Button>
      
      <CSVImportDialog
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        onImportComplete={onImportComplete}
      />
    </>
  );
};

export default CSVImportButton;
